import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardService } from './services/auth-guard.service';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterComponent } from './register/register.component';
import { BuyCoinsComponent } from './buy-coins/buy-coins.component';

const routes : Routes = [
  {path:'', component:HomeComponent},
  {path:'register', component:RegisterComponent},
  // {path:'about', component:AboutComponent}
  {path: 'reset-password', component:ResetPasswordComponent},
  {path:'dashboard', component:DashboardComponent, canActivate:[AuthGuardService]},
  {path:'transaction-history', component:TransactionHistoryComponent, canActivate:[AuthGuardService]},
  {path:'buy-coins', component:BuyCoinsComponent, canActivate:[AuthGuardService]},
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
